module.exports = __webpack_public_path__ + "img/sricon.455b4b57.png";